import { Component, input, signal } from '@angular/core';
import { QaiCallAudioIndicatorComponent, QaiCallCaptionsComponent, QaiCallVideoComponent } from '@qai/ui';
import { injectAiNotice } from 'src/app/pages/learner/call/library/ai-notice/ai-notice';
import { AvatarPlayerDirective } from 'src/app/directives/avatar-player.directive';
import { RealtimeService } from 'src/app/pages/learner/call/library/realtime/realtime.service';

@Component({
  selector: 'app-call-tavus-overlay',
  standalone: true,
  imports: [QaiCallAudioIndicatorComponent, QaiCallCaptionsComponent, QaiCallVideoComponent, AvatarPlayerDirective],
  templateUrl: './call-tavus-overlay.component.html',
  styleUrls: ['./call-tavus-overlay.component.scss'],
})
export class CallTavusOverlayComponent {
  // The account's AI notice in the sim's or learner's language; null hides it.
  protected readonly aiNotice = injectAiNotice();

  readonly captionsOn = input<boolean>(false);
  readonly captionText = input<string>('');
  readonly showCameraStream = input<boolean>(false);
  readonly captionsMaxWidth = input<number>(0);
  readonly userDisplayName = input<string>('');
  readonly userIsSpeaking = input<boolean>(false);
  readonly avatarIsSpeaking = input<boolean>(false);
  readonly showUserInitials = input<boolean>(false);
  readonly realtimeService = input<RealtimeService | undefined>(undefined);

  /** Reserved for service wiring — will be used to initiate the Tavus call */
  readonly callUuid = input<string>('');

  readonly avatarVideoPlaying = signal(false);
  readonly avatarVideoErrored = signal(false);

  protected handleAvatarVideoPlaying(): void {
    this.avatarVideoPlaying.set(true);
    this.avatarVideoErrored.set(false);
  }

  protected handleAvatarVideoError(): void {
    this.avatarVideoErrored.set(true);
    this.avatarVideoPlaying.set(false);
  }
}
